import * as React from 'react';
import { IMedia } from '../../interfaces';
import Axios from 'axios';
import Track from '../items/Track';

interface IState {
    tracks: IMedia[],
    isLoading: boolean
}

interface IProps {
    url: string,
}

export default class TracksList extends React.Component<IProps, IState>{
    private _isUnmounted:boolean = false;
    
    public state: IState = {
        tracks: [],
        isLoading: true
    };

    async componentDidMount() {
        try {
            let { data } = await Axios.get(this.props.url);

            if (this._isUnmounted) return;

            this.setState({
                tracks: data,
                isLoading: false
            });
        } catch (e) {

        }
    }

    componentWillUnmount(){
        this._isUnmounted = true;
    }

    render() {
        return (
            <div>
                {this.state.isLoading && <div className="carousel-placeholder"></div>}
                <ul>
                    {this.state.tracks.map((track: IMedia, index: number) => {
                        return (
                            <Track track={track} key={index} index={index + 1}/>
                        );
                    })}
                </ul>
            </div>
        );
    }
}